"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SummaryHeader;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _xstate = require("xstate");
var _propTypes = require("prop-types");
var _intl = require("@kyruus/intl");
var _CheckCircle = _interopRequireDefault(require("@kyruus/react-ikons/CheckCircle"));
var _PrintButton = _interopRequireDefault(require("./PrintButton"));
var _AddToCalendarButton = _interopRequireDefault(require("./AddToCalendarButton"));
var _utils = require("../../lib/utils");
var _configUtils = require("../../lib/configUtils");
var _messages = _interopRequireDefault(require("../../lib/messages"));
var _propTypes2 = require("../../lib/propTypes");
var _styles = require("./styles");
const proptypes = {
  currentState: (0, _propTypes.instanceOf)(_xstate.State).isRequired,
  track: _propTypes.func.isRequired,
  config: _propTypes2.configType
};
function SummaryHeader(_ref) {
  let {
    currentState,
    track,
    config
  } = _ref;
  const {
    provider,
    selectedAppointment,
    patientRegistration: {
      patient: {
        name
      }
    },
    bookedAppt
  } = currentState.context;
  const location = (0, _utils.getApptLocation)(provider, selectedAppointment);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_styles.PageHeading, {
    "data-testid": "SummaryHeader"
  }, /*#__PURE__*/_react.default.createElement(_styles.SummaryHeaderWithIcon, {
    "data-testid": "SummaryHeaderPatientName"
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, (0, _extends2.default)({}, _messages.default.apptBooked, {
    values: {
      firstName: name.first,
      lastName: name.last
    }
  })), /*#__PURE__*/_react.default.createElement(_CheckCircle.default, {
    size: "36px",
    "aria-hidden": true
  })), /*#__PURE__*/_react.default.createElement(_PrintButton.default, {
    track: track
  }), (0, _configUtils.isDirectBookRenderedInDrawer)(config) ? null : /*#__PURE__*/_react.default.createElement(_AddToCalendarButton.default, {
    track: track,
    provider: provider,
    appointment: selectedAppointment,
    location: location
  })), /*#__PURE__*/_react.default.createElement(_styles.AppointmentPatientInfo, null, /*#__PURE__*/_react.default.createElement(_styles.AppointmentPatientInfoLine, {
    "data-testid": "SummaryHeaderAppointmentId"
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, (0, _extends2.default)({}, _messages.default.appointmentId, {
    values: {
      appointmentId: bookedAppt.appointment_id
    }
  })))));
}
SummaryHeader.propTypes = proptypes;
SummaryHeader.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SummaryHeader",
  "props": {
    "currentState": {
      "description": "",
      "type": {
        "name": "instanceOf",
        "value": "State"
      },
      "required": true
    },
    "track": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "config": {
      "description": "",
      "type": {
        "name": "custom",
        "raw": "configType"
      },
      "required": false
    }
  }
};